<template lang='pug'>
  div
    transition(name="fade")
      router-view#app
        template(slot='svg-icons')
          svg-sprite
</template>

<script>
import SvgSprite from '@/components/SvgSprite.vue';

export default {
  name: 'App',
  components: { SvgSprite },
};

</script>

<style lang='scss'>
@import './assets/scss/plugins';
@import './assets/scss/main';
</style>
